export const ADDRESS_LENGTH: number = 0;
export const BRONX_BOROUGH: number = 1;
export const DEBOUNCE_TIME: number = 300;
export const INDEX_FOUND: number = 1;
export const INDEX_NOT_FOUND: number = -1;
export const NEW_YORK_STATE_ID: number = 33;
export const PARENT_REFUSED_TO_SIGN: string = 'Parent Refused to Sign';
export const STATEN_ISLAND_BOROUGH: number = 5;
export const OUT_OF_NEW_YORK_CITY: number = 6;
export const OUT_OF_NEW_YORK_STATE: number = 7;